import * as React from 'react';
import { useRef, useEffect } from 'react';
import { ScrollArea } from '@ai-content-hub/content-kit';
import { ChatMessage } from './ChatMessage';
import type { ChatMessageData } from './types';

export interface ChatHistoryProps {
    messages: ChatMessageData[];
    onRollback?: (version: number) => void;
    isRollbackLoading?: boolean;
    className?: string;
}

export const ChatHistory: React.FC<ChatHistoryProps> = ({
    messages,
    onRollback,
    isRollbackLoading,
    className,
}) => {
    const bottomRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages.length]);

    return (
        <ScrollArea className={className}>
            <div className="chat-history flex flex-col gap-4 px-2 py-4">
                {messages.map((msg) => (
                    <ChatMessage
                        key={msg.id}
                        message={msg}
                        onRollback={onRollback}
                        isRollbackLoading={isRollbackLoading}
                    />
                ))}
                <div ref={bottomRef} />
            </div>
        </ScrollArea>
    );
};
